module.exports = __webpack_public_path__ + "static/media/flipchart_frage.742b2b83.png";